import {action} from "typesafe-actions";
import {Package} from "@models/package";
import {RequestData} from "@models/axios";

export const enum PackagesActionTypes {
  FETCH_REQUEST = "@@packages/FETCH_REQUEST",
  FETCH_SUCCESS = "@@packages/FETCH_SUCCESS",
  FETCH_ERROR = "@@packages/FETCH_ERROR"
}

export const fetchRequest = (data: RequestData) => action(PackagesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Package[]) => action(PackagesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(PackagesActionTypes.FETCH_ERROR, message);
